import capitalize from 'lodash/capitalize';

var SNAKE_CASE_MATCH = /_\w/g;
var CAMEL_CASE_MATCH = /([A-Z])/g;

/**
 * Converts an underscore_string to a camelCase string
 * @param {string} key String to convert
 */
export var snakeToCamel = function snakeToCamel(key) {
    return key.replace(SNAKE_CASE_MATCH, function (chars) {
        return chars[1].toUpperCase();
    });
};

/**
 * Converts a camelCase string to an underscore_string
 * @param {string} key String to convert
 */
export var camelToSnake = function camelToSnake(key) {
    return key.replace(CAMEL_CASE_MATCH, function (chars) {
        return '_' + chars.toLowerCase();
    });
};

/**
 * Converts an underscore_string to an Capitalized String
 * @param {string} key String to convert
 */
export var snakeToCapitalized = function snakeToCapitalized(key) {
    return capitalize(key.replace(/_/g, ' '));
};

/**
 * Truncates a string with an elipsis
 * @param  {string}  string String to be shortened with an ellipses at the end if its too long
 * @param  {number}  length Number of characters to allow before truncation
 */
export var truncateString = function truncateString(string, length) {
    if (string.length > length) {
        return string.slice(0, length) + '...';
    }

    return string;
};

/**
 * mimics the hash implementation done on Android and iOS for determining fall back images, etc.
 * Two inputs with same contents but different order will return the same value. If you care about collisions, use `hash` below :)
 *
 * @param  {string} input String to be hashed per android and ios implementation
 * @return {string} hash of string input
 */
export var simpleStringHash = function simpleStringHash(input) {
    var hash = 0;

    if (!input) {
        return hash.toString();
    }

    return input.split('').reduce(function (memo, char) {
        return memo + char.charCodeAt(0);
    }, hash).toString();
};

var COMMA_SPACE_MULTI_SPACE_REGEX = /(,(\s+)?|\s\s+)/g;

/**
 * Splits a string by commas and spaces, removes extra white space
 *
 * @param  {string} str comma or space separated string to be split
 * @return {array}      list of split strings
 */
export var splitByCommaOrSpace = function splitByCommaOrSpace(str) {
    return str
    // change all commas to spaces and trim all multispace to single space
    .replace(COMMA_SPACE_MULTI_SPACE_REGEX, ' ')
    // split on single space
    .split(' ')
    // filter empties
    .filter(function (s) {
        return !!s;
    });
};